import EmojiPicker from './EmojiPicker';

export { EmojiPicker };
export default EmojiPicker;
